module.exports = __webpack_public_path__ + "static/img/Regular.49dde6e2.svg";